import { DefaultTheme } from 'styled-components';

import {
  breakpoints,
  fontSize,
  fontWeight,
  letterSpacing,
  lineHeight,
  spacing,
  wrapper,
  zIndex,
} from '../constants';

import { colors } from './colors';
import { fontFamily } from './fontFamily';

export const adriagateTheme: DefaultTheme = {
  colors,
  fontSize,
  fontWeight,
  fontFamily,
  lineHeight,
  letterSpacing,
  spacing,
  wrapper,
  breakpoints,
  zIndex,
};
